// Create a global instance manager
window.PopoverManager = {
  instances: [],
  init() {
    // Clean up any existing instances
    this.destroy();
    // Create new instance
    const newInstance = new PopoverSelect();
    this.instances.push(newInstance);
    return newInstance;
  },
  destroy() {
    this.instances.forEach(instance => instance.destroy());
    this.instances = [];
  }
};

class PopoverSelect {
  constructor() {
    this.trigger = document.querySelector('.popover-trigger');
    this.toggle = document.querySelector('.popover-toggle');
    this.popover = document.getElementById('SortByPopover');
    this.options = document.getElementById('SortByPopoverOptions');
    this.hiddenSelect = document.getElementById('SortBy');
    // --- ADD THIS LINE ---
    this.selectedValueDisplay = document.getElementById('SelectedSortValue');
    
    // Desktop breakpoint
    this.DESKTOP_BREAKPOINT = 1025;
    
    // Store bound event handlers so they can be removed later
    this.boundHandleOptionClick = (e) => this.handleOptionClick(e);
    this.boundHandleKeyboardNav = (e) => this.handleKeyboardNavigation(e);
    this.boundHandleEscapeKey = (e) => this.handleEscapeKey(e);
    this.boundHandleResize = () => this.handleResize();
    this.boundShowPopover = () => this.showPopover();
    this.boundHidePopover = () => this.hidePopover();
    this.boundTogglePopover = () => this.togglePopover();
    
    this.bindEvents();
  }
  
bindEvents() {
    // Click handling (primarily for mobile)
    this.toggle?.addEventListener('click', this.boundTogglePopover);
    
    // Hover handling (desktop only)
    if (this.trigger && this.isDesktop()) {
      this.trigger.addEventListener('mouseenter', this.boundShowPopover);
      this.trigger.addEventListener('mouseleave', this.boundHidePopover);
      this.trigger.hasMouseEvents = true;
    }
    
    // Option selection
    this.options?.addEventListener('click', this.boundHandleOptionClick);
    
    // Keyboard navigation
    this.options?.addEventListener('keydown', this.boundHandleKeyboardNav);
    document.addEventListener('keydown', this.boundHandleEscapeKey);
    
    // Responsive handling
    window.addEventListener('resize', this.boundHandleResize);
  }
  
  destroy() {
    // Remove all event listeners
    this.toggle?.removeEventListener('click', this.boundTogglePopover);
    this.trigger?.removeEventListener('mouseenter', this.boundShowPopover);
    this.trigger?.removeEventListener('mouseleave', this.boundHidePopover);
    this.options?.removeEventListener('click', this.boundHandleOptionClick);
    this.options?.removeEventListener('keydown', this.boundHandleKeyboardNav);
    document.removeEventListener('keydown', this.boundHandleEscapeKey);
    window.removeEventListener('resize', this.boundHandleResize);
    
    // Clean up any open popovers
    this.hidePopover();
  }
  
  isDesktop() {
    return window.innerWidth >= this.DESKTOP_BREAKPOINT;
  }
  
  showPopover() {
    this.popover?.classList.add('is-visible');
    this.toggle?.setAttribute('aria-expanded', 'true');
    this.popover?.setAttribute('aria-hidden', 'false');
  }
  
  hidePopover() {
    if (this.popover?.contains(document.activeElement)) {
      this.toggle?.focus();
    }
    
    this.popover?.classList.remove('is-visible');
    this.toggle?.setAttribute('aria-expanded', 'false');
    this.popover?.setAttribute('aria-hidden', 'true');
  }
  
  togglePopover() {
    this.popover?.classList.contains('is-visible') ? 
      this.hidePopover() : 
      this.showPopover();
  }
  
  handleOptionClick(e) {
    const option = e.target.closest('.popover-option');
    if (!option) return;
    
    // Update selection state
    this.options?.querySelectorAll('.popover-option')
      .forEach(opt => opt.setAttribute('aria-selected', 'false'));
    option.setAttribute('aria-selected', 'true');
    
    // --- ADD THIS LINE ---
    // Update the visible text in the button
    if (this.selectedValueDisplay) {
      this.selectedValueDisplay.textContent = option.textContent.trim();
    }
    
    // Update hidden select and trigger change
    if (this.hiddenSelect) {
      this.hiddenSelect.value = option.dataset.sortValue;
      this.hiddenSelect.dispatchEvent(new Event('input', { bubbles: true }));
    }
    
    this.hidePopover();
  }
  
  handleKeyboardNavigation(e) {
    if ((e.key === 'Enter' || e.key === ' ') && 
        e.target.classList.contains('popover-option')) {
      e.preventDefault();
      e.target.click();
    }
  }
  
  handleEscapeKey(e) {
    if (e.key === 'Escape' && this.popover?.classList.contains('is-visible')) {
      e.preventDefault();
      e.stopPropagation();
      this.hidePopover();
    }
  }
  
  handleResize() {
    this.hidePopover();
    
    const wasDesktop = this.trigger?.hasMouseEvents;
    const isDesktop = this.isDesktop();
    
    if (wasDesktop !== isDesktop && this.trigger) {
      if (isDesktop) {
        this.trigger.addEventListener('mouseenter', this.boundShowPopover);
        this.trigger.addEventListener('mouseleave', this.boundHidePopover);
      } else {
        this.trigger.removeEventListener('mouseenter', this.boundShowPopover);
        this.trigger.removeEventListener('mouseleave', this.boundHidePopover);
      }
      this.trigger.hasMouseEvents = isDesktop;
    }
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  window.PopoverManager.init();
});